<template>
  <div class="bind-mk-pop" @click.stop>
    <section class="pop-content1">
      <div class="g-close" @click="hideSaasPop">
        <img src="../../assets/icon-close@2x.png" width="12" alt>
      </div>
      <div>
        <h2>暂未绑定企鹅小店账号</h2>
        <div class="qrcode-wrap">
          <img class="qrcode" :src="mkBindQrcode" alt>
        </div>
        <div class="tip">
          <p>请使用微信扫一扫，在小程序中完成绑定后</p>
          <p>点击下方“我已绑定”按钮</p>
        </div>
        <p v-show="isShowErrTip" class="err-tip">
          绑定失败，请确认企鹅小店小程序已绑定
        </p>
        <div class="panel-wrap">
          <el-button
            class="bindSaasPopBtn"
            data-compname="bindSaasPopBtn"
            size="small"
            type="primary"
            data-saas_type="mk"
            @click="onConfirm"
          >
            我已绑定
          </el-button>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import commonMixin from '@/mixins/common';
import { mapState, mapGetters } from 'vuex';

export default {
  name: 'BindMkPop',
  mixins: [commonMixin],
  data() {
    return {
      isShowErrTip: false,
    };
  },
  computed: {
    ...mapState({
      profile: state => state.userCenter.profile,
      bindSaasPop: state => state.common.bindSaasPop,
    }),
    ...mapGetters({
      saasInfo: 'userCenter/saasInfo',
      isBindMk: 'userCenter/isBindMk',
    }),
    mkBindQrcode() {
      return this.getBindUrl('mk');
    },
  },
  methods: {
    getBindUrl(saasType) {
      const bindInfo = (this.profile.saas_binding || []).filter(item => item && item.mask === saasType)[0];
      return bindInfo ? bindInfo.authenticate_entry : '';
    },
    onClose() {
      console.log('close');
      this.$store.commit('common/HIDE_BIND_SAAS_POP');
      this.showBubble = false;
    },
    async onConfirm() {
      this.isShowErrTip = false;

      await this.$store.dispatch('userCenter/fetchCpProfile');
      if (!this.isBindMk) {
        this.isShowErrTip = true;

        return;
      }

      this.$tip.success('绑定企鹅小店账号成功');
      this.$store.commit('common/HIDE_BIND_SAAS_POP');
    },
    hideSaasPop() {
      this.$store.commit('common/HIDE_BIND_SAAS_POP');
    },
  },
};
</script>

<style lang="less" scoped>
@popH: 500px;
@popHeaderH: 100px;
@popFooterH: 80px;

.bind-mk-pop {
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  width: 100vw;
  height: 100vh;
  left: 0;
  top: 0;
  z-index: 3;
  background-color: rgba(0, 0, 0, 0.3);
  .g-close {
    position: absolute;
    right: 20px;
    top: 20px;
    width: 20px;
    height: 20px;
    img {
      cursor: pointer;
    }
  }
  .pop-content {
    position: relative;
    width: 800px;
    height: @popH;
    background-color: #fff;
    border-radius: 4px;
    .header {
      display: flex;
      align-items: center;
      justify-content: center;
      text-align: center;
      height: @popHeaderH;
      .title {
        margin-bottom: 10px;
      }
    }
    .inner-content {
      height: calc(@popH - @popHeaderH - @popFooterH);
      display: flex;
      justify-content: center;
      background-color: rgb(239, 239, 239);
      .guide-item {
        padding: 20px 10px;
        text-align: center;
        flex: 1;
        .tip {
          margin-bottom: 10px;
        }
      }
      .guide-item1 {
        display: flex;
        justify-content: center;
        align-items: center;
        .tip {
          margin-top: 20px;
          .em {
            color: var(--ui-main-color);
          }
        }
      }
    }

    .footer {
      display: flex;
      justify-content: center;
      align-items: center;
      height: @popFooterH;
    }
  }
  .pop-content1 {
    position: relative;
    width: 400px;
    height: 500px;
    background-color: #fff;
    border-radius: 4px;
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    .qrcode-wrap {
      width: 180px;
      height: 180px;
      margin: 0 auto;
      margin-top: 50px;
      border: 1px solid #e2e2e2;
      border-radius: 4px;
      padding: 8px;
      text-align: center;
      .qrcode {
        width: 100%;
        height: 100%;
      }
    }

    .tip,
    .err-tip {
      margin-top: 20px;
    }
    .err-tip {
      color: #f6786e;
    }
    .panel-wrap {
      margin-top: 30px;
    }
  }
}
</style>
